export default __webpack_public_path__ + "static/media/Val.ea105e92.jpg";